import getConfig from 'next/config';
import { fetchUser } from '../api/storefront';
import COMMON from '../route-constants';

const config = getConfig();
const { GF_DOTCOM_USER_SERVICE_ENDPOINT, GF_DOTCOM_ENDPOINT } =
  config.publicRuntimeConfig;

/**
 * @typedef {object} Ctx
 * @property {string} asPath
 * @property {http.IncomingMessage} req
 * @property {http.ServerResponse} res
 */

/**
 * Redirect to the login page, either by setting redirect headers if
 * server-side, or updating the window location if client-side
 * @param {Ctx} ctx
 */
export const redirectToLogin = (ctx) => {
  const { res, asPath } = ctx;
  const redirectUrl = `${GF_DOTCOM_ENDPOINT}${asPath}`;
  const loginUrl = `${GF_DOTCOM_USER_SERVICE_ENDPOINT}/users/sign_in?redirect_url=${redirectUrl}`;

  if (res) {
    res.writeHead(307, { Location: loginUrl });
    res.end();
  } else {
    window.location.replace(loginUrl);
  }
};

/**
 * Check whether session cookie is valid. If session is not valid throw
 * NOT_AUTHENTICATED error which is handled by the global error handler in
 * _error.jsx
 * @example
 * UserProfileComponent.getInitialProps = async (ctx) => {
 *   await authenticate(ctx);
 *   // This line will not be reached if auth fails
 * };
 * @param {Ctx} context
 */
export const authenticate = async (context) => {
  const user = await fetchUser({ context });
  if (user && user.email) {
    return user;
  }
  redirectToLogin(context);
  throw new Error(COMMON.PAGE_ERRORS.NOT_AUTHENTICATED);
};
